import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

var AccountDropdown = function AccountDropdown(props) {
  var accountInfo = props.accountInfo,
      authenticationState = props.authenticationState;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      firstName = _useState2[0],
      setFirstName = _useState2[1];

  useEffect(function () {
    var _props$loyalty, _props$loyalty$accoun;

    if ((_props$loyalty = props.loyalty) === null || _props$loyalty === void 0 ? void 0 : (_props$loyalty$accoun = _props$loyalty.account) === null || _props$loyalty$accoun === void 0 ? void 0 : _props$loyalty$accoun.FirstName) {
      var _props$loyalty2, _props$loyalty2$accou;

      setFirstName((_props$loyalty2 = props.loyalty) === null || _props$loyalty2 === void 0 ? void 0 : (_props$loyalty2$accou = _props$loyalty2.account) === null || _props$loyalty2$accou === void 0 ? void 0 : _props$loyalty2$accou.FirstName);
    }
  }, [props.loyalty]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
    href: "/rewards/my-info",
    className: 'cb-header__account-name'
  }, firstName));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    loyalty: state.loyalty
  };
};

export default connect(mapStateToProps, null)(AccountDropdown);